import React from 'react'
import clsx from 'clsx'
import { CloseCircle, Edit2, InfoCircle, Lock1 } from 'iconsax-react'
import { useTheme } from '@mui/material'

import SettingsEditModal from '../../SettingsEditModal'
import ColourIndicator from './ColourIndicator'
import BaseStatusIndicator from './BaseStatusIndicator'
import Tooltip from '@SonarCX/components/atoms/Tooltip'

import { useAreYouSure } from '@SonarCX/providers/AreYouSureProvider'
import useStyles from './styles'

const Edit = ({
  obj,
  objType,
  superType,
  handleDelete,
  handleEdit,
  subtext = '',
  external = false,
  locked = false,
  disableDelete = false,
  disableEdit = false
}) => {
  const theme = useTheme()

  const { setAction, setReason, setSubtext, setTitle, setV2 } = useAreYouSure()

  const [modalOpen, setModalOpen] = React.useState(false)

  const classes = useStyles()
  const isEditingUserType = objType === 'type' && superType === 'user'
  const showColorPicker = Object.keys(obj).includes('colour')

  const onDeleteClick = React.useCallback(() => {
    const action = () => {
      handleDelete(obj)
    }

    setTitle('ARE YOU SURE?')
    setAction(action)
    setReason(`Are you sure you want to delete the ${objType}: ${obj.name}?`)
    setSubtext(subtext)
    setV2(true)
  }, [
    handleDelete,
    setTitle,
    setAction,
    setReason,
    obj,
    objType,
    setSubtext,
    setV2,
    subtext
  ])

  return (
    <>
      <div className={classes.root}>
        {showColorPicker && <ColourIndicator colour={obj.colour} />}

        <div className={classes.name}>
          {locked && (
            <Tooltip
              title={
                isEditingUserType
                  ? 'This is a system type and can only be renamed. It cannot be deleted or have its external status changed.'
                  : `This is a system ${objType} and cannot be edited or deleted.`
              }
              placement='bottom-start'
              arrow
            >
              <div>
                <Lock1 size={theme.size.sm} className='lock' />
              </div>
            </Tooltip>
          )}
          {external && (
            <Tooltip title={`External Type`} placement='bottom-start' arrow>
              <div>
                <InfoCircle size={theme.size.sm} className='lock' />
              </div>
            </Tooltip>
          )}
          <label>{obj.dispName ?? obj.name}</label>
        </div>

        {Object.keys(obj).includes('base_status') && (
          <BaseStatusIndicator baseStatus={obj.base_status} />
        )}

        <div className={clsx(classes.controls, 'controls')}>
          {!disableEdit && (
            <Edit2
              size='12'
              onClick={() => setModalOpen(true)}
              style={{ marginRight: '1rem' }}
            />
          )}

          {!locked && !disableDelete && (
            <CloseCircle size={theme.size.sm} onClick={onDeleteClick} />
          )}
        </div>
      </div>

      {modalOpen && (
        <SettingsEditModal
          open={modalOpen}
          onClose={() => setModalOpen(false)}
          obj={obj}
          objType={objType}
          superType={superType}
          handleEdit={handleEdit}
          locked={locked}
        />
      )}
    </>
  )
}

export default Edit
